import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Cliente } from '../shared/model/ajustesUsuario/cliente.model';
import { UserSession } from '../shared/model/core/UserSession.model';
import { UrlConstantes } from '../utilerias/constantes/urlconstantes';
import { Usuario } from '../shared/model/security/usuario.model';
import { Persona } from '../shared/model/security/persona.model';
import { Base } from '../shared/model/core/base.model';
const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class AjustesUsuario {

  constructor(private router: Router, private http: HttpClient) { }
  getDatosUser() {
    return this.http.get<Cliente>(API_URL + 'controller/consultaDatosPersona.do', {});

  }
  getDatosSesion() {
    return this.http.post<UserSession>(UrlConstantes.getSession, {});
  }
 actulizaDatosPersona(persona :Persona){
   return this.http.post<Base>(UrlConstantes.actualizaDatosPersona,persona);
 }
}
